$(() => {
    var url: any = $('#noticia-full-url').val();
    $('#noticia-full-url').remove();
    console.log(url);

    $('#print_button').click(function () {
        $('div.PrintArea').printArea({ mode: 'iframe', extraCss: '/public/css/site/print.css' });
    });

    $('#fontA_button').click(function () {
        var tamanhoFonte = $('.noticia-info').css('font-size');
        var tf = parseFloat(tamanhoFonte);
        if (tf < 29) {
            $('.noticia-info').css({ 'font-size': tf + 5 });
        }
    });

    $('#fontD_button').click(function () {
        var tamanhoFonte = $('.noticia-info').css('font-size');
        var tf = parseFloat(tamanhoFonte);
        if (tf > 14) {
            $('.noticia-info').css({ 'font-size': tf - 5 });
        }
    });

    $('#textB_button').click(function () {
        var backG = $('.noticia-info').css('background-color');
        if (backG == 'rgb(0, 0, 0)') {
            $('.noticia-info').css({ 'background-color': '#fff' });
            $('.noticia-info').css({ color: '#333' });
        } else {
            $('.noticia-info').css({ color: 'yellow' });
            $('.noticia-info').css({ 'background-color': '#000' });
        }
    });

    $('.noticia-social-btn.fb').click(() => {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
    });

    $('.noticia-social-btn.tw').click(() => {
        window.open('http://twitter.com/share?url=' + encodeURIComponent(url), '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
    });

    //Swiper - Initialize each gallery pair
    $('.swiper-container-pair').each(function (index) {
        const $container = $(this);
        const galleryTop = new Swiper($container.find('.gallery-top')[0], {
            spaceBetween: 10,
            navigation: {
                nextEl: $container.find('.swiper-button-next')[0],
                prevEl: $container.find('.swiper-button-prev')[0],
            },
        });

        const galleryThumbs = new Swiper($container.find('.gallery-thumbs')[0], {
            spaceBetween: 10,
            centeredSlides: true,
            slidesPerView: 'auto',
            touchRatio: 0.2,
            slideToClickedSlide: true,
        });

        // Link the two swipers
        galleryTop.controller.control = galleryThumbs;
        galleryThumbs.controller.control = galleryTop;
    });

    $('img.downloadable').each(function () {
        var $this = $(this);
        $this.wrap('<a href="' + $this.attr('src') + '" download />');
    });
});
